module.exports = __webpack_public_path__ + "static/media/icon_nav_user.b4eebbb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_nav_user.svg
// module id = 335
// module chunks = 0